import styled from 'styled-components';
import theme from '../../../../theme';
/**
 * Marks group of fields as a section
 *
 * @component
 *
 * @example
 * const property = {
 *   label: 'My amazing property',
 *   name: 'myAmazingProperty',
 * }
 * return (
 * <StyledSection>
 *  <PropertyInEdit property={property}>
 *    <input className="input" />
 *  </PropertyInEdit>
 *  <p>
 *    <StyledButton>
 *      Add new item in section
 *    </StyledButton>
 *  </p>
 * </StyledSection>
 * )
 */
const StyledSection = styled.section`
  border-left: ${theme.sizes.paddingMin} solid ${theme.colors.lightBck};
  padding-left: ${theme.sizes.padding};
`;

export default StyledSection;
